import { Button, Tooltip } from "@mui/material";
import "./AddButton.css";

interface AddButtonProps {
  onAddClick: () => void;
  addLabel: string;
  maxWidth?: string;
  disabled?: boolean;
  icon?: any;
  minWidth?: string;
  tooltip?: string;
}

const AddButton: React.FC<AddButtonProps> = ({ onAddClick, addLabel, maxWidth, disabled, icon, minWidth="64px", tooltip }) => {
  return (
    <Tooltip title={tooltip ? tooltip : null}>
      <div style={{ display: 'block', width: '100%' }}>
        <Button
          onClick={onAddClick}
          className="add-button"
          disabled={disabled}
          sx={{
            width: "100%",
            maxWidth: maxWidth,
            minWidth: minWidth,
            backgroundColor: disabled ? "#ccc" : "#1B51A7",
            color: disabled ? "#666" : "#fff",
            fontSize: 14,
            textTransform: "capitalize",
            "&:hover": {
              backgroundColor: "#1B51A7",
            },
            display: 'flex',
            gap: '10px'
          }}
        >
          {icon && <img src={icon} alt='icon' />}
          {addLabel}
        </Button>
      </div>
    </Tooltip>
  );
};

export default AddButton;
